import React, { Fragment } from 'react';
import DocumentTitle from 'react-document-title';

import CareersPage from '../components/company/careers-page';

const CareersRoute = () => (
  <Fragment>
    <DocumentTitle title="Careers | NerdWallet" />
    <CareersPage />
  </Fragment>
);

CareersRoute.displayName = 'CareersRoute';
CareersRoute.analyticsName = 'careers_page';
CareersRoute.segmentPageName = 'careers';

export default CareersRoute;
